import React from 'react';
import { motion } from 'framer-motion';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-page">
      <motion.div
        className="privacy-container"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="privacy-header">
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last Updated: February 14, 2026</p>
        </div>

        <div className="privacy-content">
          <section className="privacy-section">
            <h2>1. Introduction</h2>
            <p>
              Leviathan Coding Systems ("we", "our", or "us") respects your privacy and is committed to protecting your personal data. 
              This privacy policy explains how we collect, use, and safeguard your information when you visit our website.
            </p>
          </section>

          <section className="privacy-section">
            <h2>2. Information We Collect</h2>
            <h3>Contact Form Information</h3>
            <p>When you submit our contact form, we collect:</p>
            <ul>
              <li>Full name</li>
              <li>Email address</li>
              <li>Company name (optional)</li>
              <li>Message content</li>
            </ul>
            <p>
              This information is processed through Web3Forms, a third-party service, and sent directly to our business email.
            </p>

            <h3>Automatically Collected Information</h3>
            <p>We may automatically collect:</p>
            <ul>
              <li>Browser type and version</li>
              <li>Device information</li>
              <li>IP address (anonymized)</li>
              <li>Pages visited and time spent on site</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>3. Third-Party Services</h2>
            
            <h3>Google Fonts</h3>
            <p>
              We use Google Fonts to enhance the visual presentation of our website. Google may collect technical information 
              such as IP addresses. Please refer to{' '}
              <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
                Google's Privacy Policy
              </a> for more information.
            </p>

            <h3>Web3Forms</h3>
            <p>
              Our contact form is powered by Web3Forms. When you submit the form, your information is processed by Web3Forms 
              and delivered to our email. Please refer to{' '}
              <a href="https://web3forms.com/privacy" target="_blank" rel="noopener noreferrer">
                Web3Forms Privacy Policy
              </a> for more information.
            </p>
          </section>

          <section className="privacy-section">
            <h2>4. How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Respond to your inquiries and contact requests</li>
              <li>Provide information about our services</li>
              <li>Improve our website and user experience</li>
              <li>Protect against spam and abuse</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>5. Data Storage and Security</h2>
            <p>
              Your contact form submissions are stored in our business email system. We implement appropriate technical and 
              organizational measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction.
            </p>
          </section>

          <section className="privacy-section">
            <h2>6. Cookies</h2>
            <p>
              We use localStorage to remember your cookie consent preference. This is not technically a "cookie" but serves a 
              similar purpose. We do not use tracking cookies or third-party advertising cookies.
            </p>
          </section>

          <section className="privacy-section">
            <h2>7. Your Rights</h2>
            <p>Under GDPR and UK data protection laws, you have the right to:</p>
            <ul>
              <li>Access your personal data</li>
              <li>Correct inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Object to processing of your data</li>
              <li>Data portability</li>
              <li>Withdraw consent at any time</li>
            </ul>
            <p>
              To exercise any of these rights, please contact us at{' '}
              <a href="mailto:contact@leviathancodingsystems.com">contact@leviathancodingsystems.com</a>
            </p>
          </section>

          <section className="privacy-section">
            <h2>8. Data Retention</h2>
            <p>
              We retain contact form submissions for as long as necessary to respond to your inquiry and maintain business records. 
              Typically, this is no longer than 2 years unless required by law or legitimate business interests.
            </p>
          </section>

          <section className="privacy-section">
            <h2>9. Children's Privacy</h2>
            <p>
              Our website is not intended for children under 16 years of age. We do not knowingly collect personal information 
              from children. If you believe we have collected information from a child, please contact us immediately.
            </p>
          </section>

          <section className="privacy-section">
            <h2>10. Changes to This Policy</h2>
            <p>
              We may update this privacy policy from time to time. We will notify you of any changes by posting the new policy 
              on this page and updating the "Last Updated" date.
            </p>
          </section>

          <section className="privacy-section">
            <h2>11. Contact Us</h2>
            <p>
              If you have any questions about this privacy policy or our data practices, please contact us:
            </p>
            <p>
              Email: <a href="mailto:contact@leviathancodingsystems.com">contact@leviathancodingsystems.com</a>
            </p>
            <p>
              Location: North West England, United Kingdom
            </p>
          </section>
        </div>

        <div className="privacy-footer">
          <a href="/" className="back-home-btn">
            ← Back to Home
          </a>
        </div>
      </motion.div>
    </div>
  );
};

export default PrivacyPolicy;
